import { render, staticRenderFns } from "./Dnd.vue?vue&type=template&id=957aa714&scoped=true&"
import script from "./Dnd.vue?vue&type=script&lang=js&"
export * from "./Dnd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957aa714",
  null
  
)

export default component.exports